import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchCertificationProviders, FetchCertificationProvidersSuccess } from 'app/library/certification-provider/actions';
import { CertificationProvider } from 'app/library/certification-provider/models/certification-provider';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

export class CertificationProviderDataSource implements DataSource<CertificationProvider> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredCertificationProvider$: Observable<CertificationProvider[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<CertificationProvider[]> {
        return this._filteredCertificationProvider$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadCertificationProviders(pageSize?: number, pageNumber?: number, search?: string, types?: number[], statuses?: number[]): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchCertificationProviders({
                pageSize,
                pageNumber,
                search,
                types,
                statuses,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchCertificationProvidersSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
